import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  CompaniesPage,
  DocumentsPage,
  UserGroupsPage,
  UsersPage,
  SettingsPage,
  AuditPage,
  TasksPage,
  AccessRestrictionStampPage,
  UserProfilePage,
  DocumentsWorkPage,
  TasksWorkPage,
  ChangePassPage,
  ChangePersonalDataPage,
  ChangeAvatarPage,
} from "pages";

const Router = () => {
  return (
    <Switch>
      <Route path="/documents" component={DocumentsPage} />
      <Route path="/users" component={UsersPage} />
      <Route path="/usersGroup" component={UserGroupsPage} />
      <Route path="/company" component={CompaniesPage} />
      <Route path="/settings" component={SettingsPage} />
      <Route path="/audit" component={AuditPage} />
      <Route path="/tasks" component={TasksPage} />
      <Route
        path="/accessRestrictionStamp"
        component={AccessRestrictionStampPage}
      />
      <Route path="/profile" component={UserProfilePage} />
      <Route path="/myTasks" component={TasksWorkPage} />
      <Route path="/editableDocuments" component={DocumentsWorkPage} />
      <Route path="/changeAvatar" component={ChangeAvatarPage} />
      <Route path="/changePersonalData" component={ChangePersonalDataPage} />
      <Route path="/changePass" component={ChangePassPage} />
    </Switch>
  );
};

export default Router;
